module.exports = __webpack_public_path__ + "img/icon-show-group-1.2e7e3620.svg";